import { render } from "./AssociarView.vue?vue&type=template&id=85b3a8e2"
import script from "./AssociarView.vue?vue&type=script&lang=js"
export * from "./AssociarView.vue?vue&type=script&lang=js"

import "./AssociarView.vue?vue&type=style&index=0&id=85b3a8e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__